/**
 * google api expects route to have a lat & lng key in the array of objects
 * 
 * This function takes the possible keys from the arrays it's given to make the polyline
 * 
 * agm data - could have Est_Lat && Est_Lng or Real_Lat && Real_Lng
 * agm data should prioritize Real_Lat && Real_Lng over Est_Lat && Est_Lng
 * sc data - will have lat && lng properties
 * 
 * @param {*} data 
 * 
 * @returns original object with the new lat and lng
 * 
 * @category Utils
 */
export const adaptCoordinates = (data) => {
    if (!Array.isArray(data)) {
        console.warn("adaptCoordinates: Expected an array but got", data);
        return [];
    }

    return data
        .filter(point => point && typeof point === "object") // remove null/undefined
        .map(point => {
            let newLat, newLng;

            if ('Real_Lat' in point && 'Real_Lng' in point &&
                point.Real_Lat != null && point.Real_Lng != null &&
                point.Real_Lat !== '' && point.Real_Lng !== '' &&
                point.Real_Lat !== 0 && point.Real_Lng !== 0) {
                newLat = point.Real_Lat;
                newLng = point.Real_Lng;
            }
            else if ('Est_Lat' in point && 'Est_Lng' in point &&
                point.Est_Lat != null && point.Est_Lng != null &&
                point.Est_Lat !== '' && point.Est_Lng !== '' &&
                point.Est_Lat !== 0 && point.Est_Lng !== 0) {
                newLat = point.Est_Lat;
                newLng = point.Est_Lng;
            }
            else if ('lat' in point && 'lng' in point &&
                point.lat != null && point.lng != null &&
                point.lat !== '' && point.lng !== '' &&
                point.lat !== 0 && point.lng !== 0) {
                newLat = point.lat;
                newLng = point.lng;
            }
            else {
                console.warn("adaptCoordinates: Skipping invalid coordinate object", point);
                return null; // Mark as invalid
            }

            return {
                ...point,
                lat: newLat,
                lng: newLng
            };
        })
        .filter(Boolean); // remove nulls from invalid points
};


